import * as React from "react"
import stringHelper from "@digits-shared/helpers/stringHelper"
import colors from "@digits-shared/themes/colors"
import * as HoverCardPrimitive from "@radix-ui/react-hover-card"
import styled from "styled-components"

export type PseudoTargetDirection = "upward" | "downward"

const StyledHoverPopoverContent = styled(HoverCardPrimitive.Content)`
  position: relative;
  background: ${colors.white};
  padding: 8px;
  border-radius: 8px;
  z-index: 10;
  box-shadow: 0 0 12px 0 ${colors.translucentSecondary20};

  &.upward,
  &.downward {
    &:before {
      position: absolute;
      z-index: -1;
      left: 0;
      width: 50%;

      top: -18px;
      bottom: 0;

      background: transparent;
      content: "";
      cursor: pointer;
    }
    &.upward::before {
      top: 0;
      bottom: -18px;
    }
  }
`

export interface HoverPopoverProps {
  align?: "start" | "center" | "end"
  side?: "top" | "right" | "bottom" | "left"
  pseudoTargetDirection?: PseudoTargetDirection
  sideOffset?: number
  className?: string
  onClick?: React.MouseEventHandler<HTMLElement>
}

/**
 * EXAMPLE USAGE:
 * <HoverPopover>
 *   <HoverPopoverTrigger asChild>
 *     -- place trigger component here--
 *   </HoverPopoverTrigger>
 *   <HoverPopoverContent>
 *     -- place content here--
 *   </HoverPopoverContent>
 * </Popover>
 */
export const HoverPopoverArrow = HoverCardPrimitive.Arrow
export const HoverPopover = HoverCardPrimitive.Root
export const HoverPopoverTrigger = HoverCardPrimitive.Trigger
export const HoverPopoverContent = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<HoverPopoverProps>
>(
  (
    {
      children,
      className,
      onClick,
      align = "center",
      side = "bottom",
      pseudoTargetDirection,
      sideOffset = 4,
    },
    forwardedRef
  ) => (
    <HoverCardPrimitive.Portal>
      <StyledHoverPopoverContent
        sideOffset={sideOffset}
        align={align}
        side={side}
        ref={forwardedRef}
        hideWhenDetached
        className={stringHelper.classNames(className, pseudoTargetDirection)}
        onClick={onClick}
      >
        {children}
      </StyledHoverPopoverContent>
    </HoverCardPrimitive.Portal>
  )
)
